import {
  AtsMessageInboxConversationsDocument,
  PaginatedQueryPageInfoFragment,
} from 'generated/resources/graphql'

import { usePaginatedQuery } from 'modules/core/hooks/usePaginatedQuery'

interface Props {
  accessId: string
  watcher: boolean
  archived: boolean
}

const DEFAULT_CONNECTION: {
  pageInfo: PaginatedQueryPageInfoFragment
  edges: {
    cursor: string
    node: unknown
  }[]
} = {
  pageInfo: {
    hasNextPage: false,
  },
  edges: [],
}

export const useMessageInboxConversations = ({ accessId, archived, watcher }: Props) => {
  const {
    data,
    loading: loadingConversations,
    controls: { fetchMore: fetchMoreConversations, hasMore: hasMoreConversations },
  } = usePaginatedQuery(AtsMessageInboxConversationsDocument, {
    extractConnection: (dataToExtract) =>
      dataToExtract.ats.conversationsConnection ?? DEFAULT_CONNECTION,
    variables: { accessId, archived, watcher },
  })
  const conversations = data?.ats.conversationsConnection.edges || []

  return {
    conversations,
    loadingConversations,
    fetchMoreConversations,
    hasMoreConversations,
  }
}
